import { render, staticRenderFns } from "./ReportRtcTable.vue?vue&type=template&id=20e60393"
import script from "./ReportRtcTable.vue?vue&type=script&lang=js"
export * from "./ReportRtcTable.vue?vue&type=script&lang=js"
import style0 from "./ReportRtcTable.vue?vue&type=style&index=0&id=20e60393&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports